import "../css/app.scss";
import "./common/header";
import { setup } from "./live_view_boilerplate";
setup({});
